import React, { useState, useEffect } from "react";
import api from "../../api/axios"; // ✅ axios personnalisé
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Grid,
} from "@mui/material";
import DataTable from "examples/Tables/DataTable";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

const Expenditures = () => {
  const [expenditures, setExpenditures] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [expenditureFormData, setExpenditureFormData] = useState({
    description: "",
    amount: "",
    date: "",
  });

  useEffect(() => {
    const fetchExpenditures = async () => {
      setLoading(true);
      try {
        const response = await api.get("/quickbooks/expenditures/");
        console.log("Expenditure: ", response.data.expenditures);
        setExpenditures(response.data.expenditures);
      } catch (err) {
        console.error("Failed to fetch expenditures:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchExpenditures();
  }, []);

  const handleDialogOpen = () => setOpenDialog(true);
  const handleDialogClose = () => setOpenDialog(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setExpenditureFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    try {
      await api.post("/quickbooks/expenditures/", expenditureFormData);
      setExpenditures((prev) => [...prev, expenditureFormData]);
      handleDialogClose();
    } catch (err) {
      console.error("Error creating expenditure:", err);
    }
  };

  const columns = [
    { Header: "Description", accessor: "description", align: "left" },
    { Header: "Amount", accessor: "amount", align: "right" },
    { Header: "Date", accessor: "date", align: "left" },
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Grid container justifyContent="flex-end" padding={2}>
        <Button variant="contained" color="primary" onClick={handleDialogOpen}>
          Add Expenditure
        </Button>
      </Grid>
      <DataTable table={{ columns, rows: expenditures }} isLoading={loading} />
      <Dialog open={openDialog} onClose={handleDialogClose}>
        <DialogTitle>Add Expenditure</DialogTitle>
        <DialogContent>
          <TextField
            label="Description"
            name="description"
            value={expenditureFormData.description}
            onChange={handleInputChange}
            fullWidth
            margin="dense"
          />
          <TextField
            label="Amount"
            name="amount"
            value={expenditureFormData.amount}
            onChange={handleInputChange}
            fullWidth
            margin="dense"
          />
          <TextField
            label="Date"
            name="date"
            value={expenditureFormData.date}
            onChange={handleInputChange}
            fullWidth
            margin="dense"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose}>Cancel</Button>
          <Button onClick={handleSubmit} color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog>
      <Footer />
    </DashboardLayout>
  );
};

export default Expenditures;
